import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { PPUPickupPaymentModel } from '../models/deliver-customer.model';
import { RequestPaymentComponent } from '@app/pages/authenticated/components/request-payment/request-payment.component';
import { BypassPaymentComponent } from '@app/pages/authenticated/components/bypass-payment/bypass-payment.component';

@Injectable({
  providedIn: 'root',
})
export class RequestPaymentService {
  private paymentStatusSubject = new BehaviorSubject<number[]>([]);
  private paymentConfirmationSubject = new BehaviorSubject<{ orderIds: number[]; isPaymentCollected: boolean }>({
    orderIds: [],
    isPaymentCollected: false,
  });
  paymentStatus = this.paymentStatusSubject.asObservable();
  paymentConfirmation = this.paymentConfirmationSubject.asObservable();
  constructor(private dialog: MatDialog) {}

  public requestPayment(data: PPUPickupPaymentModel): Observable<any> {
    const dialogRef = this.dialog.open(RequestPaymentComponent, {
      data: data,
      disableClose: true,
    });

    return dialogRef.afterClosed();
  }

  public bypassPayment(data: PPUPickupPaymentModel): Observable<any> {
    const dialogRef = this.dialog.open(BypassPaymentComponent, {
      data: data,
      disableClose: true,
    });

    return dialogRef.afterClosed();
  }

  public paymentStatusSubscription(orderIds: number[]) {
    this.paymentStatusSubject.next(orderIds);
  }

  public paymentConfirmationSubscription(orderIds: number[], isPaymentCollected: boolean) {
    this.paymentConfirmationSubject.next({ orderIds, isPaymentCollected });
  }
}
